<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <aside id="sidebar" class="w-64 bg-white border-r border-gray-200 h-screen sticky top-16">
    <nav class="p-4">
      <ul class="space-y-2">
        <li>
          <span class="flex items-center space-x-3 p-3 rounded-lg bg-primary/10 text-primary font-medium cursor-pointer">
            <i class="fas fa-tachometer-alt"></i>
            <span>{{ $t('trader.sidebar.dashboard') }}</span>
          </span>
        </li>
        <li>
          <span class="flex items-center space-x-3 p-3 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
            <i class="fas fa-book"></i>
            <span>{{ $t('trader.sidebar.credit_ledger') }}</span>
          </span>
        </li>
        <li>
          <span class="flex items-center space-x-3 p-3 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
            <i class="fas fa-exchange-alt"></i>
            <span>{{ $t('trader.sidebar.transfer_credits') }}</span>
          </span>
        </li>
        <li>
          <span class="flex items-center space-x-3 p-3 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
            <i class="fas fa-fire"></i>
            <span>{{ $t('trader.sidebar.retire_credits') }}</span>
          </span>
        </li>
        <li>
          <span class="flex items-center space-x-3 p-3 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
            <i class="fas fa-search"></i>
            <span>{{ $t('trader.sidebar.market_explorer') }}</span>
          </span>
        </li>
        <li>
          <span class="flex items-center space-x-3 p-3 rounded-lg text-gray-600 hover:bg-gray-50 cursor-pointer">
            <i class="fas fa-chart-line"></i>
            <span>{{ $t('trader.sidebar.portfolio_analytics') }}</span>
          </span>
        </li>
      </ul>
    </nav>
  </aside>
</template>